import { environments } from '../environments/environment';
import { IPaginationParam } from '../lib/ajax-helper';
import { ajax } from '@setel/webcommon/exposes/ajax';
import { UserBadgeStatus } from '../shared/interfaces/badges.interface';

const BASE_URL = `${environments.apiOpsBaseUrl}/api/rewards`;

export async function getUserBadges(
  userId: string,
  status: UserBadgeStatus,
  pagination: IPaginationParam,
) {
  return ajax.get(`${BASE_URL}/admin/user-badges/${userId}?status=${status}`, {params: pagination});
}